(function () {
  if (!window.location.pathname.includes('/products/')) return;

  function run(variants) {
    var total = 0;
    variants.forEach(function (v) {
      if (v.mgmt && v.qty > 0) total += v.qty;
    });
    if (total >= 1 && total <= 2) injectBadge(total);
  }

  if (window.charmaInventory) {
    run(window.charmaInventory);
    return;
  }

  // Fallback: wait briefly in case script order is off
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    if (window.charmaInventory) {
      clearInterval(timer);
      run(window.charmaInventory);
    } else if (attempts >= 10) {
      clearInterval(timer);
    }
  }, 200);

  function injectBadge(qty) {
    if (document.getElementById('charma-low-stock')) return;

    var style = document.createElement('style');
    style.textContent =
      '@keyframes charma-pulse{0%,100%{opacity:1}50%{opacity:.65}}' +
      '#charma-low-stock{' +
        'display:inline-flex;align-items:center;gap:8px;' +
        'background:linear-gradient(135deg,#fff8e7,#fff3d6);' +
        'color:#92400e;' +
        'border:1.5px solid #f59e0b;' +
        'border-radius:24px;' +
        'padding:7px 16px;' +
        'font-size:13px;font-weight:700;letter-spacing:0.3px;' +
        'margin:10px 0 14px;' +
        'box-shadow:0 2px 8px rgba(245,158,11,.18);' +
      '}' +
      '#charma-low-stock .cls-dot{' +
        'width:8px;height:8px;border-radius:50%;' +
        'background:#f59e0b;flex-shrink:0;' +
        'animation:charma-pulse 1.2s ease-in-out infinite;' +
      '}';
    document.head.appendChild(style);

    var badge = document.createElement('div');
    badge.id = 'charma-low-stock';

    var dot = document.createElement('span');
    dot.className = 'cls-dot';

    var text = document.createElement('span');
    var pl = (document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0;
    text.textContent = qty === 1
      ? (pl ? 'Została ostatnia sztuka!' : 'Zostáva posledný kus!')
      : (pl ? 'Zostały tylko ' + qty + ' sztuki!' : 'Zostávajú už len ' + qty + ' kusy!');

    badge.appendChild(dot);
    badge.appendChild(text);

    var selectors = [
      '.product__price',
      '.price',
      '.product-single__price',
      '[data-product-price]',
      'form[action="/cart/add"]',
      '.product-form',
      '.product-form__submit',
      '[name="add"]'
    ];

    var done = false;
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.parentNode.insertBefore(badge, el);
        done = true;
        break;
      }
    }
    if (!done) {
      var h1 = document.querySelector('h1');
      if (h1) h1.insertAdjacentElement('afterend', badge);
    }
  }
})();
